import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
// ✅ 引入 Element Plus
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

const app = createApp(App)

// ✅ 注册 Element Plus
app.use(ElementPlus)
app.use(router)
// ✅ 挂载应用
app.mount('#app')
